<!-- 环境质量因子管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增因子
      </el-button>
      <el-button
        type="danger"
        @click="onBatchDelete()"
        :disabled="!selectedIds || !selectedIds.length"
      >
        <i class="fas fa-trash-alt"></i> 删除因子
      </el-button>
      <div class="former">
        <select2
          v-model="form.IpcFactorTypeID"
          url="basic?type=businesstype"
          labelName="Name"
          placeholder="请选择因子类型"
          no-data-text="无类型"
        ></select2
        >&nbsp;
        <select2
          v-model="form.IpcCategoryID"
          url="basic?type=category"
          labelName="Name"
          placeholder="请选择污染物指标类型"
          no-data-text="无类型"
        ></select2
        >&nbsp;
        <el-input
          clearable
          v-model="form['Name:like']"
          placeholder="因子名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-input
          clearable
          v-model="form['Code:like']"
          placeholder="因子编码"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      size="medium"
      :data="itemList"
      v-loading="loading"
      @select="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <el-table-column type="selection" checked="true"></el-table-column>
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="因子名称"></el-table-column>
      <el-table-column
        prop="Code"
        label="212编码"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="EnglishName"
        label="英文名称"
        width="120"
      ></el-table-column>
      <el-table-column label="因子类型" width="120">
        <template slot-scope="{ row }">
          {{ row.IpcFactorType ? row.IpcFactorType.Name : "" }}
        </template>
      </el-table-column>
      <!--<el-table-column label="指标类型" width="120">
        <template slot-scope="{ row }">
          {{ row.IpcCategory ?  row.IpcCategory.Name : '' }}
        </template>
      </el-table-column> -->
      <el-table-column label="计量单位" width="120" prop="MeasureUnit.Name">
        <!-- <template slot-scope="{ row }">
          {{ row.IpcMeasureUnit ?  row.IpcMeasureUnit.Name : '' }}
        </template> -->
      </el-table-column>
      <el-table-column
        prop="ChemicalSymbol"
        label="化学符号"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="DefaultDataType"
        label="缺省数据类型"
        width="140"
      ></el-table-column>
      <el-table-column label="是否使用" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsUseOrNot" type="success">使用中</el-tag>
          <el-tag v-else type="primary">未使用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="OrderByNum"
        label="排序值"
        width="100"
      ></el-table-column>
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :isEdit="isEdit"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        IpcFactorTypeID: "",
        IpcCategoryID: "",
        "Name:like": "",
        "Code:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      isEdit: false,
      selectedIds: [],
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("ipcfactor", {
          params: {
            where: this.form,
            with: [
              "IpcFactorType",
              "IpcCategory",
              "MeasureUnitGroup",
              "MeasureUnit",
            ],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.isEdit = false;
      this.itemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.isEdit = true;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此因子吗？", "提示")
        .then(() => this.$axios.delete(`ipcfactor/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    handleSelectionChange(list) {
      this.selectedIds = [];
      list.forEach((item) => {
        this.selectedIds.push(item.ID);
      });
    },
    onBatchDelete() {
      this.$confirm("确定要删除选中因子吗？", "提示")
        .then(() =>
          this.$axios.delete("ipcfactor/batchdelete", {
            params: { FIDS: this.selectedIds },
          })
        )
        .then(() => {
          this.getItemList();
          this.selectedIds = [];
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        FactorID: null,
        Code: "",
        Name: "",
        ShortName: "",
        EnglishName: "",
        FactorGroup: "",
        IpcFactorTypeID: null, // 因子类型
        ChemicalSymbol: "",
        CASNumber: "",
        ShortNameHTML: "",
        FullNameHTML: "",
        IpcMeasureUnit: null, // 计量单位
        IpcMeasureUnits: null,
        DecimalDigit: 3,
        IsUseOrNot: true,
        IsCalAPIOrNot: true,
        OrderByNum: 1000,
        Remark: "",
      };
    },
  },
};
</script>
